import dayjs from 'dayjs';

export const DATE_FORMAT = 'YYYY-MM-DD';

const formatter = date => dayjs(date).format(DATE_FORMAT);

export const getToday = () => formatter(new Date());

export const isFutureDate = date => !!date && dayjs(date).isAfter(dayjs(), 'day');

export const get7DaysBefore = () => formatter(dayjs().subtract(6, 'day'));

export const DATE_PRESETS = ['today', 'yesterday', 'last7', 'last30', 'thisMonth'];

export const getPresetRange = preset => {
  const today = dayjs();
  switch (preset) {
    case 'today':
      return [formatter(today), formatter(today)];
    case 'yesterday':
      return [formatter(today.subtract(1, 'day')), formatter(today.subtract(1, 'day'))];
    case 'last30':
      return [formatter(today.subtract(29, 'day')), formatter(today)];
    case 'thisMonth':
      return [formatter(today.startOf('month')), formatter(today)];
    case 'last7':
    default:
      return [formatter(today.subtract(6, 'day')), formatter(today)];
  }
};

export const getRangeLength = ([start, end]) => dayjs(end).diff(dayjs(start), 'day') + 1;

export const getPreviousRange = ([start, end]) => {
  const length = getRangeLength([start, end]);
  return [
    formatter(dayjs(start).subtract(length, 'day')),
    formatter(dayjs(start).subtract(1, 'day')),
  ];
};

export const enumerateDays = ([start, end], limit = 1100) => {
  const days = [];
  let cursor = dayjs(start);
  const last = dayjs(end);
  while (!cursor.isAfter(last) && days.length < limit) {
    days.push(formatter(cursor));
    cursor = cursor.add(1, 'day');
  }
  return days;
};
